module.exports = __webpack_public_path__ + "static/media/LFEX-Logo.22a5fe8b.png";